import { useEffect, useState } from 'react'

/**
 * Возвращает «отстоявшееся» значение input-а через `delayMs` мс после
 * последнего изменения. Используется в фильтрах/поиске списков,
 * чтобы `queryKey` не менялся на каждый нажатый символ и не дёргал
 * Supabase на каждый keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs = 250): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(t)
  }, [value, delayMs])

  return debounced
}
